import {changeAreaDecimals} from "../operations/formats";

export const actions = {
	undo: view => view.undo(),
	redo: view => view.redo(),
	"hide-gridlines": view => view.hideGridlines("toggle"),
	"hide-headers": view => view.hideHeaders("toggle"),
	"freeze-columns": view => view.freezeColumns(),
	"freeze-rows": view => view.freezeRows(),
	"show-formulas": view => view.showFormulas("toggle"),
	"print-borders": view => view.showPrintBorders("toggle"),
	span: view => {
		if(Object.keys(view._table.getAllSelectAreas()).length !== 1)
			return view.alert({
				text: webix.i18n.spreadsheet.labels["error-merge-multiselect"], type: "alert-error"
			});

		const range = view.$$("cells").getSelectArea();
		if (range) {
			if (isMerged(view, range))
				view.splitCell();
			else {
				const values = [];
				for (let r = range.start.row; r <= range.end.row; r++){
					for (let c = range.start.column; c <= range.end.column; c++){
						let value = view.getCellValue(r, c);
						if (value) values.push(value);
						if (values.length > 1) break;
					}
					if (values.length > 1) break;
				}
				if (values.length > 1) {
					view.confirm({
						text: webix.i18n.spreadsheet.labels["merge-cell-confirm"]
					}).then(() => view.combineCells());
				} else
					view.combineCells();
			}
		}
	},	
	"increase-decimals": view => changeAreaDecimals(view, 1),
	"decrease-decimals": view => changeAreaDecimals(view, -1),
	"increase-indent": view => view.callEvent("onStyleSet", ["indent", 1]),
	"decrease-indent": view => view.callEvent("onStyleSet", ["indent", -1]),

	"find-readonly": view => view.callEvent("onCommand",[{ id:"find" }])
};

function isMerged(view,range){
	const c0 = range.start;
	const c1 = range.end;

	for (let i = c0.row * 1; i <= c1.row * 1; i++){
		for (let j = c0.column * 1; j <= c1.column * 1; j++){
			if (view.$$("cells").getSpan(i, j))
				return true;
		}
	}
	return false;
}
